import { PageConfig } from '../../type';

export const acvfDuMoisViewSchema: PageConfig = {
    config: {
        modelName: 'ACVF du mois',
        itemName: 'un ACVF',
        apiUrl: '/views/ACVFDuMois',
        options: ['order', 'filter'],
        indentifier: 'acvfDuMoisSchema',
    },
    schemas: [
        // ID club, raison sociale, prenom nom, adresse + cp, No postal, localité, téléphone, publicité

        {
            style: { width: 220 },
            ref: 'mandat/ref',
            title: 'id Club',
            type: 'ref',
            search: true,
        },
        {
            style: { width: 220 },
            ref: 'personneMorale/raisonSociale',
            title: 'Raison Sociale',
            search: true,
        },
        {
            style: { width: 220 },
            ref: 'prenom nom',
            title: 'Prenom Nom',
            ban: ['order', 'filter'],
        },
        {
            style: { width: 220 },
            ref: 'personneMorale/adresse/ligne1',
            title: 'Adresse',
        },
        {
            style: { width: 220 },
            ref: 'personneMorale/adresse/NPA',
            title: 'Npa',
            type: 'amount',
        },
        {
            style: { width: 220 },
            ref: 'personneMorale/adresse/region',
            title: 'Localité',
        },
        {
            style: { width: 220 },
            ref: 'personneMorale/telephone',
            title: 'Téléphones',
        },
        {
            style: { width: 220 },
            ref: 'publicite',
            title: 'Publicité',
        },
        {
            style: { width: 220, isDisplayInTable: false },
            ref: 'dateAccord',
            title: 'Date Accord',
            type: 'date',
        },
        {
            style: { width: 220, isDisplayInTable: false },
            ref: 'reconductionNonRenouvelée',
            title: 'Reconduction Non Renouvelée',
            type: 'bool',
        },
        {
            style: { width: 220, isDisplayInTable: false },
            ref: 'dateStorno',
            title: 'Date Storno',
            type: 'date',
        },
        {
            style: { width: 220, isDisplayInTable: false },
            ref: 'annulation',
            title: 'Annulation',
            type: 'bool',
        },
    ],
};
